import styled, { css } from 'styled-components';
import { backgrounds } from 'polished';
import { white } from 'color-name';
import { ThemeDefinitions } from '../../styles/ThemeComponents';

interface ISpeaker {
  background?: string;
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  background: none;
  flex-direction: column;
  height: 100%;
  padding: 50px 20px;

  > div.title {
    font-size: 24px;
    color: #fff;
    text-align: left;
    max-width: 300px;

    
    margin: auto;
    margin-top: 40px;

    > h2 {
     
    }

    padding: 10px 30px;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  z-index: 20;
  margin-top: 30px;
`;

export const Speaker = styled.div<ISpeaker>`
  width: 300px;
  height: 300px;
  background: url(${props => props.background || '/assets/logo.png'}) no-repeat
    center center;
  background-size: cover;
  margin: 5px;
  position: relative;
  transition: 0.5s all;

  > div {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.1);
    /*background: linear-gradient(185deg, rgba(255,91,0,0.3) 57%, rgba(255,91,0,1) 85%); */
    background: linear-gradient(185deg, rgba(50,70,107,0) 57%, rgb(50,70,107) 85%);
    height: 100%;
    justify-content: flex-end;
    padding-bottom: 30px;
    color: #fff;
    padding: 20px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    transition: 0.5s all;
    flex-direction: column;
    height: auto;
    height: 100%;



    > h2 {
      font-size: 20px;
      padding: 0px;
      transition: 0.5s all;
      color: #fff !important;
    }

    > p {
      font-size: 12px;
      padding: 0px;
      transition: 0.5s all;
      height: 30px;
      overflow: hidden;
      >p{
        line-height: 14px;
      }

    }
  }

  &:hover {
    > div {
      height: 100%;
      justify-content: flex-end;
      padding-bottom: 30px;
      background:   rgba(250, 100, 0, 0.7);
     
      > p {
        font-size: 12px;
        height: auto;
        overflow: auto;
      }
    }
  }

  @media (max-width: 750px) {
    width: 150px;
    height: 150px;

    > div {
      padding: 10px;
      > h2 {
        font-size: 10px;
        font-weight: bold;
        padding: 0px;
        transition: 0.5s all;
      }

      > p {
        font-size: 10px;
        padding: 0px;
        transition: 0.5s all;
        height: 12px;
        overflow: hidden;
      }
    }

    &:hover {
      > div {
        height: 100%;
        justify-content: flex-end;
        padding-bottom: 20px;
        > p {
          font-size: 10px;
          height: auto;
          overflow: auto;
        }
      }
    }
  }
`;
